import { z } from 'zod';
/**
 * Desired presentation rotation for a screen mount.
 * HDMI output usually stays landscape; players rotate the playback stage.
 */
export const ScreenRotationDegreesSchema = z.union([
    z.literal(0),
    z.literal(90),
    z.literal(180),
    z.literal(270),
]);
export const ScreenOrientationSchema = z.enum(['landscape', 'portrait']);
/** Human label derived from mount rotation — never an independent write source. */
export function orientationFromRotationDegrees(degrees) {
    return degrees === 90 || degrees === 270 ? 'portrait' : 'landscape';
}
/**
 * Legacy create payloads that only sent orientation map to a conventional mount.
 * Portrait → 90°; landscape → 0°. Prefer rotationDegrees for new clients.
 */
export function rotationDegreesFromOrientation(orientation) {
    return orientation === 'portrait' ? 90 : 0;
}
/**
 * Resolve the rotation to persist on create.
 * Explicit rotationDegrees wins; otherwise map legacy orientation; else 0.
 */
export function resolveCreateRotationDegrees(input) {
    if (input.rotationDegrees !== undefined)
        return input.rotationDegrees;
    if (input.orientation !== undefined) {
        return rotationDegreesFromOrientation(input.orientation);
    }
    return 0;
}
//# sourceMappingURL=screen-rotation.js.map